<div class="form-group row">
    <label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.COMMON.CITY' | localize }}<i class="text-danger">*</i></label>
    <div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
        <mat-select class="form-control"
                    placeholder="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.COMMON.CITY' | localize }}"
                    [(ngModel)]="selectedCity"
                    name="city"
                    #city="ngModel"
                    (selectionChange)="onChangeCity()"
                    required>
            <mat-option>
                {{ 'FE.ORDER.FORMS.COMBOBOX.COMMON.CHOOSE' | localize }}
            </mat-option>
            <mat-option *ngFor="let city of (cities | async)" [value]="city">{{city.cityName}}</mat-option>
        </mat-select>
        <!--<span *ngIf="showIsRequiredCityMessage" class="help-block" style="color: tomato;">Bu Alan Boş Bırakılamaz</span>-->
        <mat-error *ngIf="city.hasError('required')">{{ 'FE.REQUIREDFIELDS.COMMON.REQUIRED' | localize }}</mat-error>
    </div>
</div>
<div class="form-group row">
    <label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.TRANSFER.SOURCELOCATION' | localize }}<i class="text-danger">*</i></label>
    <div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">

        <mat-select class="form-control"
                    placeholder="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.TRANSFER.SOURCELOCATION' | localize }}"
                    [(ngModel)]="selectedAddressObj"
                    name="address"
                    #address="ngModel"
                    (selectionChange)="onChangeLocation()"
                    (click)="onClickLocation()"
                    required>
            <mat-option>
                <ngx-mat-select-search [formControl]="addressSearchFilter"
                                       placeholderLabel="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.TOREQUESTSALESSTATICLOCATION.LOCATIONADDRESS' | localize }}"
                                       noEntriesFoundLabel=""
                                       ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngIf="isLocationNotFound">{{ 'FE.ORDER.FORMS.PLACEHOLDERS.TOREQUESTSALESSTATICLOCATION.LOCATIONADDRESS.NOTFOUND' | localize }}"</mat-option>

            <mat-option *ngIf="addressSearchFilter.value?.length < 3 && 0 < addressSearchFilter.value?.length">{{ 'FE.ORDER.FORMS.PLACEHOLDERS.COMMON.MINLETTER' | localize }}</mat-option>

            <mat-option *ngFor="let address of (locationObjListByCity | async)" [value]="address">
                {{address.name}}
            </mat-option>
        </mat-select>
        <!--<mat-error *ngIf="address.hasError('required')">{{ 'FE.REQUIREDFIELDS.COMMON.REQUIRED' | localize }}</mat-error>-->

        <div *ngIf="address.invalid && (address.dirty || address.touched)"
             class="mat-error">
            <div *ngIf="address.errors.required">
                {{ 'FE.REQUIREDFIELDS.COMMON.REQUIRED' | localize }}
            </div>
            
        </div>



    </div>
</div>